import { useEffect, useRef, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import logoMark from '../../assets/images/Logos/kole-medical-emblem.svg';

// The platform's own header, used instead of the main site Navbar on every /events page.
// Desktop: brand, section links, then the way back to the main site and the Client Admin button.
// Phones: brand and a ☰ menu holding all four as large rows ("Client Admin Portal" there).
export default function EventsHeader() {
  const [open, setOpen] = useState(false);
  const { pathname, hash } = useLocation();
  const headerRef = useRef<HTMLElement>(null);
  const toggleRef = useRef<HTMLButtonElement>(null);

  // A new page (or section) closes the menu
  useEffect(() => setOpen(false), [pathname, hash]);

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") { setOpen(false); toggleRef.current?.focus(); }
    };
    const onPointer = (e: MouseEvent) => {
      if (!headerRef.current?.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("keydown", onKey);
    document.addEventListener("mousedown", onPointer);
    return () => {
      document.removeEventListener("keydown", onKey);
      document.removeEventListener("mousedown", onPointer);
    };
  }, [open]);

  return (
    <header className="evp-header" ref={headerRef}>
      <div className="km-container evp-header-inner">
        <Link to="/events" className="evp-brand" aria-label="Kole Medical Webinars & Workshops home">
          <img src={logoMark} alt="" width={40} height={40} />
          <span className="evp-brand-name">Kole Medical</span>
          <span className="evp-brand-product">Webinars &amp; Workshops</span>
        </Link>

        <button
          ref={toggleRef}
          type="button"
          className={`evp-menu-toggle${open ? " is-open" : ""}`}
          aria-expanded={open}
          aria-controls="evp-menu"
          aria-label={open ? "Close menu" : "Open menu"}
          onClick={() => setOpen(o => !o)}
        >
          <span /><span /><span />
        </button>

        <div id="evp-menu" className={`evp-menu${open ? " is-open" : ""}`}>
          <nav className="evp-nav" aria-label="Webinars & Workshops">
            {/* Highlighted on the webinars list only: a webinar's own page isn't "Upcoming webinars" */}
            <NavLink to="/events" end className={({ isActive }) => (isActive && hash !== "#how" ? "is-active" : "")}>Upcoming webinars</NavLink>
            <Link to={{ pathname: "/events", hash: "#how" }} className={pathname === "/events" && hash === "#how" ? "is-active" : ""}>How it works</Link>
          </nav>

          <div className="evp-header-actions">
            <Link to="/" className="evp-mainsite">
              <span aria-hidden="true">←</span> Kole Medical main site
            </Link>
            {/* A shortcut only: the admin's data is protected by sign-in and the database either way */}
            <Link to="/admin/login" className="evp-admin">
              <span aria-hidden="true">🔒</span> <span>Client Admin<span className="evp-admin-more"> Portal</span></span>
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
}
